(function () {
  function isSidebar() {
    return window.matchMedia('(min-width: 990px)').matches;
  }

  function navigateSort(value) {
    var url = new URL(window.location.href);
    url.searchParams.set('sort_by', value);
    url.searchParams.delete('page');
    window.location.href = url.toString();
  }

  function closeAllSortMenus(except) {
    document.querySelectorAll('.coll-sort.is-open').forEach(function (menu) {
      if (menu === except) return;
      menu.classList.remove('is-open');
      var toggle = menu.querySelector('[data-sort-toggle]');
      if (toggle) toggle.setAttribute('aria-expanded', 'false');
    });
  }

  /* --- Filter-Sidebar (Desktop): bei Änderung sofort anwenden --- */
  document.addEventListener('change', function (event) {
    var form = event.target.closest('.coll-filters__form');
    if (form && isSidebar()) {
      if (form.requestSubmit) {
        form.requestSubmit();
      } else {
        form.submit();
      }
    }
  });

  /* --- Sortier-Dropdown (eigenes Menü) + Filter-Drawer öffnen --- */
  document.addEventListener('click', function (event) {
    /* Sortieren: umschalten */
    var toggle = event.target.closest('[data-sort-toggle]');
    var inMenu = event.target.closest('.coll-sort');
    closeAllSortMenus(inMenu);

    if (toggle) {
      var menu = toggle.closest('.coll-sort');
      var open = menu.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      return;
    }

    /* Sortieren: Option gewählt */
    var option = event.target.closest('[data-sort-value]');
    if (option) {
      navigateSort(option.getAttribute('data-sort-value'));
      return;
    }

    /* Filter: „Mehr anzeigen“ umschalten */
    var more = event.target.closest('[data-filter-more]');
    if (more) {
      var list = more.closest('.coll-filters__options');
      if (list) {
        var expanded = list.classList.toggle('is-expanded');
        more.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      }
      return;
    }

    /* Filter-Drawer öffnen */
    var trigger = event.target.closest('[data-filter-open]');
    if (trigger) {
      var drawer = document.querySelector('collection-filters');
      if (drawer) drawer.open();
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') closeAllSortMenus();
  });

  /* --- Filter-Drawer (Mobil) --- */
  if (!customElements.get('collection-filters')) {
    class CollectionFilters extends HTMLElement {
      connectedCallback() {
        this.onKeydown = this.onKeydown.bind(this);
        this.querySelectorAll('[data-filter-close]').forEach((el) => {
          el.addEventListener('click', () => this.close());
        });
      }

      disconnectedCallback() {
        document.removeEventListener('keydown', this.onKeydown);
        document.body.style.overflow = '';
      }

      open() {
        this.classList.add('is-open');
        this.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
        document.addEventListener('keydown', this.onKeydown);
      }

      close() {
        this.classList.remove('is-open');
        this.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
        document.removeEventListener('keydown', this.onKeydown);
      }

      onKeydown(event) {
        if (event.key === 'Escape') this.close();
      }
    }
    customElements.define('collection-filters', CollectionFilters);
  }
})();
